import './Markdown.scss';

import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

export default function Markdown({ children, className }) {
  const classes = `markdown ${className}`;

  return (
    <ReactMarkdown
      className={classes}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  );
}

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Markdown.defaultProps = {
  className: '',
};
